


























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FormItem extends Vue {
  isOpen: boolean = false;

  @Prop({ type: Object, required: true })
  readonly item!: any;

  get compArrowDirection(): string {
    return this.isOpen ? 'form-item-main-arrow-up' : 'form-item-main-arrow-down';
  }

  get compBranchName(): string {
    if (this.item.branch) {
      return `Antenne de ${this.item.branch.city} (${this.item.branch.departmentNumber})`;
    }
    return 'Antenne non renseignée';
  }

  toggleComponent(): void {
    this.isOpen = !this.isOpen;
  }
}
